/**
 * @fileoverview Shared language configuration for KaraoNow.
 * @summary Centralized supported languages for both backend and frontend.
 *
 * @package @karaonow/shared
 * @module constants/languages
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */
/**
 * @summary List of supported languages.
 * @constant
 * @type {readonly string[]}
 */
export const SUPPORTED_LANGUAGES = ['fr', 'en', 'es', 'it', 'pt', 'ja', 'zh', 'ko'];
/**
 * @summary Native display name for each supported language (language name in its own language).
 * @constant
 */
export const LANGUAGE_LABELS = {
    fr: 'Français',
    en: 'English',
    es: 'Español',
    it: 'Italiano',
    pt: 'Português',
    ja: '日本語',
    zh: '中文',
    ko: '한국어',
};
/**
 * @summary Check if a language is supported.
 * @param {string} lang - The language code to check.
 * @returns {boolean} True if the language is supported, false otherwise.
 */
export function isSupportedLanguage(lang) {
    return typeof lang === 'string' && SUPPORTED_LANGUAGES.includes(lang);
}
/**
 * @summary Get default language.
 * @returns {SupportedLanguage} The default language (French).
 */
export function getDefaultLanguage() {
    return 'fr';
}
//# sourceMappingURL=languages.js.map